import { z } from 'zod'

export const TopupStatusEnum = z.enum(['pending', 'approved', 'declined'])
export type TopupStatus = z.infer<typeof TopupStatusEnum>

export const TopupTypeEnum = z.enum(['card', 'invoice'])
export type TopupType = z.infer<typeof TopupTypeEnum>
